import { WaitlistEntry } from 'api/model'
import { useEffect, useState } from 'react'
import { adminListWaitlist } from 'api/endpoints/jelledFromFileSpecWithTransformer'

function useFetchWaitlist() {
  const [waitlist, setWaitlist] = useState<WaitlistEntry[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true)

      try {
        const response = await adminListWaitlist()
        setWaitlist(response.data)
      } catch (error) {
        setError(`${error}`)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    isLoading,
    waitlist,
    error,
    setWaitlist,
  }
}

export { useFetchWaitlist }
